import React from "react";

export const PageBackground = () => (
    <div className="page-background">
        <div className="overlay" />
    </div>
);
